import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class HtmlTagService {
  renderer: Renderer2;
  element: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  addTag({
    tag = "",
    id = "",
    identifier = "",
    src = "",
    text = "",
    type = "",
    async = "",
    defer = "",
    rel = "",
    href = "",
    position = "head",
    mode = "add",
    as = "",
    media = "",
    eventCallback = "",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    callback = () => {},
    charset = "",
    data = {}
  }) {
    const parent =
      position === "head"
        ? this.document.head
        : position === "body"
          ? this.document.body
          : (this.document.getElementsByClassName(position)[0] as HTMLElement);
    const renderer = this.renderer;

    if (parent && parent.getElementsByClassName(identifier)) {
      this.element = parent.getElementsByClassName(identifier)[0];
    }

    if (this.element && mode === "remove") {
      renderer.removeChild(parent, this.element);
      return this.element;
    } else if (!this.element && mode === "add") {
      this.element = renderer.createElement(tag);

      if (identifier) {
        this.element.setAttribute("class", identifier);
      }

      if (id) {
        this.element.setAttribute("id", id);
      }

      if (src) {
        this.element.setAttribute("src", src);
      }

      if (type) {
        this.element.setAttribute("type", type);
      }

      if (async) {
        this.element.setAttribute("async", async);
      }

      if (defer) {
        this.element.setAttribute("defer", defer);
      }

      if (rel) {
        this.element.setAttribute("rel", rel);
      }

      if (href) {
        this.element.setAttribute("href", href);
      }

      if (as) {
        this.element.setAttribute("as", as);
      }

      if (media) {
        this.element.setAttribute("media", media);
      }

      if (charset) {
        this.element.setAttribute("charset", charset);
      }

      if (data) {
        for (const [key, value] of Object.entries(data)) {
          this.element.setAttribute(`data-${key}`, value);
        }
      }

      if (text) {
        if (this.element.text !== undefined) {
          this.element.text = text;
        } else if (this.element.innerText !== undefined) {
          this.element.innerText = text;
        }
      }

      if (eventCallback) {
        this.element.addEventListener(eventCallback, callback);
      }

      renderer.appendChild(parent, this.element);
    }

    return this.element;
  }
}
